import { useState } from "react";
import { C, uid, fmt, Btn, Input, Select, Textarea, Modal, Section, StatCard, Tabs, useIsMobile, SEMILLAS_OPC } from "./ui";

// ─── TAB STOCK FARDOS ──────────────────────────────────────
function TabStockFardos({ fardos, potreros, onUpdate }) {
  const [show, setShow] = useState(false);
  const [pasto, setPasto] = useState("");
  const [tipo, setTipo] = useState("Redondo");
  const [cantidad, setCantidad] = useState("");
  const [pesoPromedio, setPesoPromedio] = useState("");
  const [potreroId, setPotreroId] = useState(potreros[0]?.id || "");
  const [packer, setPacker] = useState("");
  const [obs, setObs] = useState("");

  const guardar = () => {
    if (!pasto || !cantidad) return;
    onUpdate([...fardos, {
      id: uid(),
      pastoPrincipal: pasto,
      tipo,
      cantidad: parseInt(cantidad) || 0,
      pesoPromedio: parseFloat(pesoPromedio) || 0,
      potreroId,
      fecha: new Date().toISOString().slice(0, 10),
      packer,
      estado: "disponible",
      obs,
    }]);
    setShow(false);
    setPasto("");
    setCantidad("");
    setPesoPromedio("");
    setPacker("");
    setObs("");
  };

  const eliminar = (id) => onUpdate(fardos.filter(f => f.id !== id));

  const estadoCounts = {
    disponible: fardos.filter(f => f.estado === "disponible").length,
    distribuido: fardos.filter(f => f.estado === "distribuido").length,
    consumido: fardos.filter(f => f.estado === "consumido").length,
  };

  const totalFardos = fardos.reduce((s, f) => s + (f.cantidad || 0), 0);

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8, marginBottom: 16 }}>
        <StatCard val={totalFardos} label="fardos totales" />
        <StatCard val={estadoCounts.disponible} label="disponibles" color={C.pasto} />
        <StatCard val={estadoCounts.distribuido} label="distribuidos" color={C.warn} />
        <StatCard val={estadoCounts.consumido} label="consumidos" color={C.muted} />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
        <Btn variant="primary" onClick={() => setShow(true)} disabled={potreros.length === 0}>
          + Registrar fardo
        </Btn>
      </div>

      {fardos.length === 0 && !show && (
        <div style={{ textAlign: "center", padding: "40px 20px", color: C.muted }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📦</div>
          <div style={{ fontSize: 13 }}>Registrá fardos enfardados para llevar control del stock.</div>
        </div>
      )}

      {fardos.map((f) => {
        const potrero = potreros.find(p => p.id === f.potreroId);
        const pesoTotal = (f.cantidad || 0) * (f.pesoPromedio || 0);
        return (
          <div key={f.id} style={{
            background: f.estado === "consumido" ? "#F5F5F5" : C.white,
            borderRadius: 9, padding: "10px 14px", marginBottom: 6,
            border: `1.5px solid ${C.arenaDark}`, display: "flex", justifyContent: "space-between", alignItems: "flex-start"
          }}>
            <div>
              <div>
                <span style={{ fontWeight: 600, fontSize: 13, color: C.tierra }}>{f.pastoPrincipal}</span>
                <span style={{ fontSize: 11, color: C.muted, marginLeft: 8 }}>{f.tipo}</span>
                <span style={{ fontSize: 11, color: C.muted, marginLeft: 8, padding: "2px 6px", background: C.arena, borderRadius: 4 }}>
                  {f.estado === "disponible" ? "📦 Disponible" : f.estado === "distribuido" ? "🚚 Distribuido" : "✓ Consumido"}
                </span>
              </div>
              <div style={{ fontSize: 12, color: C.texto, marginTop: 4 }}>
                <span>{f.cantidad} fardos</span>
                {f.pesoPromedio > 0 && <span> · {pesoTotal} kg total</span>}
              </div>
              {potrero && <div style={{ fontSize: 11, color: C.muted, marginTop: 3 }}>📍 {potrero.nombre}</div>}
              {f.packer && <div style={{ fontSize: 11, color: C.muted }}>Packer: {f.packer}</div>}
              {f.obs && <div style={{ fontSize: 11, color: C.muted, fontStyle: "italic", marginTop: 2 }}>{f.obs}</div>}
            </div>
            <Btn size="sm" variant="danger" onClick={() => eliminar(f.id)}>×</Btn>
          </div>
        );
      })}

      {show && (
        <div style={{ background: C.fondo, borderRadius: 10, padding: 16, border: `1px solid ${C.arenaDark}`, marginTop: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: C.tierra, marginBottom: 12 }}>Nuevo fardo</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 12px" }}>
            <Select label="Tipo de pasto" value={pasto} onChange={setPasto} required
              options={[{v:"",l:"— Elegí pasto —"}, ...SEMILLAS_OPC.map(s=>({v:s,l:s}))]} />
            <Select label="Tipo de fardo" value={tipo} onChange={setTipo} options={["Redondo", "Cuadrado", "Megafardo"]} />
            <Input label="Cantidad de fardos" value={cantidad} onChange={setCantidad} type="number" required placeholder="Ej: 80" />
            <Input label="Peso promedio (kg)" value={pesoPromedio} onChange={setPesoPromedio} type="number" placeholder="Ej: 32" />
            <Select label="Potrero" value={potreroId} onChange={setPotreroId}
              options={potreros.map(p => ({ v: p.id, l: p.nombre }))} />
            <Input label="Packer" value={packer} onChange={setPacker} placeholder="Ej: Packer A" />
          </div>
          <Textarea label="Observaciones" value={obs} onChange={setObs} rows={2} />
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <Btn variant="ghost" onClick={() => setShow(false)} style={{ flex: 1 }}>Cancelar</Btn>
            <Btn variant="primary" onClick={guardar} disabled={!pasto || !cantidad} style={{ flex: 1 }}>Guardar fardo</Btn>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── TAB DISTRIBUCIÓN ──────────────────────────────────────
function TabDistribucion({ fardos, potreros, onUpdateFardo }) {
  const [modo, setModo] = useState("animales"); // "animales" o "potrero"
  const [fardoSelId, setFardoSelId] = useState("");
  const [seleccionAnimales, setSeleccionAnimales] = useState([]);
  const [potreroSel, setPotreroSel] = useState("");
  const [cantDist, setCantDist] = useState("");

  const fardoSel = fardos.find(f => f.id === fardoSelId);
  const maxDist = fardoSel?.cantidad || 0;
  const nDist = Math.min(parseInt(cantDist) || 0, maxDist);

  const vivosDe = (p) => (p.animalesAsignados || []).filter(a => (a.estado || "activo") === "activo").length;
  const todos = potreros.flatMap(p => (p.animalesAsignados || [])
    .filter(a => (a.estado || "activo") === "activo")
    .map(a => ({ id: a.id, caravana: a.caravana, categoria: a.categoria, especie: a.especie, potreroId: p.id, potreroNombre: p.nombre })));

  const selSet = new Set(seleccionAnimales);
  const toggle = (a) => {
    if (selSet.has(a.id)) setSeleccionAnimales(prev => prev.filter(x => x !== a.id));
    else setSeleccionAnimales(prev => [...prev, a.id]);
  };

  const reset = () => { setFardoSelId(""); setSeleccionAnimales([]); setPotreroSel(""); setCantDist(""); };

  // Distribuye nDist fardos: descuenta del stock del fardo y registra el destino
  const distribuir = (destino) => {
    if (!fardoSel || nDist <= 0) return;
    const restante = maxDist - nDist;
    const dist = { fecha: new Date().toISOString().slice(0, 10), cantidad: nDist, ...destino };
    onUpdateFardo({
      ...fardoSel,
      cantidad: restante,
      estado: restante > 0 ? "disponible" : "distribuido",
      distribuciones: [...(fardoSel.distribuciones || []), dist],
    });
    reset();
  };
  const distribuirAnimales = () => {
    if (seleccionAnimales.length === 0) return;
    distribuir({ modo: "animales", animales: seleccionAnimales });
  };
  const distribuirPotrero = () => {
    if (!potreroSel) return;
    const pot = potreros.find(p => p.id === potreroSel);
    distribuir({ modo: "potrero", potreroId: potreroSel, potreroNombre: pot?.nombre });
  };

  return (
    <div>
      <div style={{ fontSize: 12, color: C.muted, marginBottom: 14 }}>
        Seleccioná un fardo disponible y distribuílo por animales o por potrero completo.
      </div>

      <Select label="Fardo disponible" value={fardoSelId}
        onChange={(v) => { setFardoSelId(v); const f = fardos.find(x => x.id === v); setCantDist(f ? String(f.cantidad) : ""); }}
        options={[{ v: "", l: "Seleccionar fardo..." }, ...fardos.filter(f => f.estado === "disponible" && f.cantidad > 0).map(f => ({
          v: f.id,
          l: `${f.pastoPrincipal} (${f.cantidad} ${f.tipo}s disponibles)`
        }))]} />

      {fardoSel && (
        <div style={{ background: C.arena, borderRadius: 9, padding: 12, marginBottom: 14, borderLeft: `4px solid ${C.pasto}` }}>
          <div style={{ fontWeight: 600, fontSize: 12, color: C.tierra }}>{fardoSel.pastoPrincipal}</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 2, marginBottom: 10 }}>
            {fardoSel.cantidad} fardos {fardoSel.tipo} disponibles · {fardoSel.pesoPromedio > 0 ? `${fardoSel.cantidad * fardoSel.pesoPromedio} kg` : "—"}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 12, color: C.tierra, fontWeight: 600 }}>¿Cuántos distribuir?</span>
            <input type="number" value={cantDist} min={1} max={maxDist}
              onChange={e => setCantDist(e.target.value)}
              style={{ width: 80, padding: "7px 9px", border: `1.5px solid ${C.arenaDark}`, borderRadius: 7,
                fontSize: 15, fontWeight: 700, textAlign: "right", color: C.tierra, background: C.white }} />
            <span style={{ fontSize: 12, color: C.muted }}>de {maxDist}</span>
          </div>
        </div>
      )}

      {fardoSel && (
        <>
          <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
            <button onClick={() => { setModo("animales"); setPotreroSel(""); }} style={{
              flex: 1, padding: "8px 12px", borderRadius: 8, border: "none", cursor: "pointer",
              background: modo === "animales" ? C.pasto : C.arena, color: modo === "animales" ? "white" : C.muted,
              fontWeight: modo === "animales" ? 600 : 400, fontSize: 12
            }}>🐄 Por animales</button>
            <button onClick={() => { setModo("potrero"); setSeleccionAnimales([]); }} style={{
              flex: 1, padding: "8px 12px", borderRadius: 8, border: "none", cursor: "pointer",
              background: modo === "potrero" ? C.pasto : C.arena, color: modo === "potrero" ? "white" : C.muted,
              fontWeight: modo === "potrero" ? 600 : 400, fontSize: 12
            }}>📍 Por potrero</button>
          </div>

          {modo === "animales" ? (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div style={{ fontSize: 12, color: C.muted }}>{seleccionAnimales.length} animales seleccionados de {todos.length}</div>
                <Btn size="sm" variant="secondary" onClick={() => setSeleccionAnimales(selSet.size === todos.length ? [] : todos.map(a => a.id))}>
                  {selSet.size === todos.length ? "Deseleccionar todos" : "Seleccionar todos"}
                </Btn>
              </div>

              {todos.length === 0 ? (
                <div style={{ fontSize: 12, color: C.muted, textAlign: "center", padding: "20px 0" }}>Sin animales activos</div>
              ) : (
                <div style={{ maxHeight: 280, overflowY: "auto", border: `1px solid ${C.arenaDark}`, borderRadius: 8, marginBottom: 14 }}>
                  {todos.map((a, i) => (
                    <div key={a.id} onClick={() => toggle(a)}
                      style={{
                        display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", cursor: "pointer",
                        background: selSet.has(a.id) ? C.pastoLight + "22" : "transparent",
                        borderBottom: i < todos.length - 1 ? `1px solid ${C.arenaDark}` : "none"
                      }}>
                      <input type="checkbox" checked={selSet.has(a.id)} onChange={() => toggle(a)} onClick={e => e.stopPropagation()} style={{ cursor: "pointer" }} />
                      <span style={{ fontFamily: "monospace", fontSize: 12, color: C.tierra }}>#{a.caravana}</span>
                      <span style={{ fontSize: 11, color: C.muted }}>{a.categoria}</span>
                      <span style={{ fontSize: 11, color: C.muted, marginLeft: "auto" }}>{a.potreroNombre}</span>
                    </div>
                  ))}
                </div>
              )}

              <Btn variant="primary" onClick={distribuirAnimales} disabled={seleccionAnimales.length === 0 || nDist <= 0} style={{ width: "100%" }}>
                Distribuir {nDist} fardo{nDist !== 1 ? "s" : ""} a {seleccionAnimales.length} animal{seleccionAnimales.length !== 1 ? "es" : ""}
              </Btn>
            </>
          ) : (
            <>
              <Select label="Seleccionar potrero" value={potreroSel} onChange={setPotreroSel}
                options={[{ v: "", l: "Elegí potrero..." }, ...potreros.map(p => ({
                  v: p.id,
                  l: `${p.nombre} · 🐄 ${vivosDe(p)} animales · ${p.ha.toFixed(1)} ha`
                }))]} />

              {potreroSel && (
                <div style={{ background: C.pastoLight + "22", borderRadius: 8, padding: 12, marginBottom: 14, borderLeft: `4px solid ${C.pasto}` }}>
                  <div style={{ fontSize: 12, color: C.tierra, fontWeight: 600 }}>
                    {potreros.find(p => p.id === potreroSel)?.nombre}
                  </div>
                  <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
                    🐄 {vivosDe(potreros.find(p => p.id === potreroSel) || {})} animales vivos
                    {nDist > 0 && <> · {(nDist / Math.max(1, vivosDe(potreros.find(p => p.id === potreroSel) || {}))).toFixed(1)} fardos/animal</>}
                  </div>
                </div>
              )}

              <Btn variant="primary" onClick={distribuirPotrero} disabled={!potreroSel || nDist <= 0} style={{ width: "100%" }}>
                Distribuir {nDist} fardo{nDist !== 1 ? "s" : ""} al potrero
              </Btn>
            </>
          )}
        </>
      )}
    </div>
  );
}

// ─── FARDOS PANEL (exported) ──────────────────────────────
export function FardosPanel({ fardos, potreros, onUpdate, onUpdateFardo }) {
  const isMobile = useIsMobile();
  const [tab, setTab] = useState("stock");
  const tabs = [
    { id: "stock", label: "📦 Stock de Fardos" },
    { id: "dist", label: "🚚 Distribuir" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: isMobile?"column":"row", flex: 1, overflow: "hidden" }}>
      {/* ── SIDEBAR ── */}
      <aside style={{ width: isMobile?"100%":280, background: C.white,
        borderRight: isMobile?"none":`1px solid ${C.arenaDark}`,
        borderBottom: isMobile?`1px solid ${C.arenaDark}`:"none",
        overflowY: "auto", flexShrink: 0, maxHeight: isMobile?"45%":"none" }}>
        <Section label="Estado">
          {(() => {
            const total = fardos.reduce((s, f) => s + (f.cantidad || 0), 0);
            const disponible = fardos.filter(f => f.estado === "disponible").reduce((s, f) => s + (f.cantidad || 0), 0);
            const distribuido = fardos.filter(f => f.estado === "distribuido").reduce((s, f) => s + (f.cantidad || 0), 0);
            return (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                <StatCard val={total} label="fardos" color={C.tierra} />
                <StatCard val={disponible} label="disponibles" color={C.pasto} />
              </div>
            );
          })()}
        </Section>
      </aside>

      {/* ── MAIN ── */}
      <div style={{ flex: 1, overflowY: "auto", background: C.fondo }}>
        <div style={{ padding: "16px 20px" }}>
          <Tabs tabs={tabs} active={tab} onChange={setTab} />
          {tab === "stock" && <TabStockFardos fardos={fardos} potreros={potreros} onUpdate={onUpdate} />}
          {tab === "dist" && <TabDistribucion fardos={fardos} potreros={potreros} onUpdateFardo={onUpdateFardo} />}
        </div>
      </div>
    </div>
  );
}
